itsoftApp.createModule("btnEffect", function () {
    const module = this;

    class BtnEffect {
        constructor(btn) {
            this.btn = btn;
            this.events = ['mouseenter', 'mouseout'];
            this.rect = null;
            this.helper = null;
            this.x = null;
            this.y = null;
    
            this.init();
        }

        getPositions(e) {
            this.rect = this.btn.getBoundingClientRect();
            this.x = e.pageX - this.rect.left;
            this.y = e.clientY - this.rect.top;

            this.showHelper();
        }

        createHelper() {
            this.helper = document.createElement('I');
            this.btn.appendChild(this.helper);
        }

        showHelper() {
            this.helper.style.top = `${this.y}px`;
            this.helper.style.left = `${this.x}px`;
        }

        addListeners(evt) {
            this.btn.addEventListener(evt, (e) => this.getPositions(e));
        }
    
        addEvents() {
            this.events.forEach((evt) => this.addListeners(evt));
        }

        bindEvents() {
            this.getPositions = this.getPositions.bind(this);
        }
    
        init() {
            this.bindEvents();
            this.createHelper();
            this.addEvents();
        }
    }
    
    const btns = document.querySelectorAll('.js-btn-effect');
    if (btns.length > 0) {
        btns.forEach((btn) => new BtnEffect(btn));
    }
    
    module.callback = BtnEffect;
});

